declare function mergeState(state: any): any
declare function emitRuntime(): void
/* global runtime, authorizedPost, mergeState, emitRuntime */
async function payrollPaymentDateAction(action: string, runId: string, metadata: any) {
  const businessId = runtime.activeBusinessId
  const result = await authorizedPost('payrollRunMutationHttp', { businessId, action, runId, metadata })
  if (runtime.activeBusinessId !== businessId) throw new Error(window.PlummeI18n.t('err.payrollDate.stale'))
  if (result.state) runtime.appState = mergeState(result.state)
  emitRuntime(); window.dispatchEvent(new Event('plumme-employees-changed'))
  return result.run || runtime.appState.payrollRuns.find((run: any) => run.id === runId)
}
